// extracted by mini-css-extract-plugin
module.exports = {"qa-note-tooltip-body":"style_qa-note-tooltip-body__nelaw"};